
webpack.register(
    'components/tooltip-icon/tooltip-container/tooltip-container',
    function() {
        return require('components/tooltip-icon/tooltip-container/tooltip-container');
    },
    false
);
var stache = require('can/view/stache/stache');
module.exports = stache("<can-import from='components/tooltip-icon/tooltip-container/tooltip-container'/>\r\n\r\n<div class=\"c-tooltip-icon\">\r\n    <div class=\"s-tooltip-icon\">\r\n        <span class=\"s-tooltip-icon__inner js-tooltip-icon\">i</span>\r\n    </div>\r\n    <tooltip-container text=\"{{text}}\" />\r\n</div>");